import Dialog from "src/components/Dialog";
import { useTranslation } from "react-i18next";

export default function NoAudioDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("babyStation.noAudioDialog.heading")}
      text={t("babyStation.noAudioDialog.text")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
